import { Box, Typography } from "@mui/material";
import useColors from "../api/hooks/useColors";

const LabelComponentProp = ({
  label,
  icon = undefined,
  children,
  textTypography = "overline",
  sx = {},
  alignItems = "center",
}) => {
  const colors = useColors();
  return (
    <Box
      display={"flex"}
      flexDirection={"column"}
      alignItems={alignItems}
      minHeight={"60px"}
      padding={0}
      justifyContent={"space-around"}
      gap={"12px"}
      color={colors.text_secondary}
      sx={{
        ...sx,
      }}
    >
      <Box display={"flex"} flexDirection={"row"} gap={0.5}>
        <Typography variant={textTypography} lineHeight={1.2}>
          {label}
        </Typography>
        {icon && icon}
      </Box>

      <div
        style={{
          display: "flex",
          alignItems: "center",
          fontSize: "12px",
          justifyContent: "space-between",
          width: "100%",
        }}
      >
        {children}
      </div>
    </Box>
  );
};

export default LabelComponentProp;
